import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

// const LS_ROUTE_KEY = "platform";
// const exclude = [];
// const excludeStarts = ["/u"];

const routes: Array < RouteRecordRaw > = [{
		path: '/',
		name: 'base',
		component: HomeView,
		children: [{
				name: 'home',
				path: '',
				components: {
					sidemain: () => import('../pages/Main.vue'),
				},
			},
			{
				name: 'aboutus',
				path: '/t/about',
				components: {
					sidemain: () => import('../pages/techtitans/AboutUs.vue'),
				},
			},
			{
				name: 'college',
				path: '/t/colleges',
				components: {
					sidemain: () => import('../pages/techtitans/Colleges.vue'),
				},
			},
			// {
			// 	name: 'ourvalues',
			// 	path: '/t/values',
			// 	components: {
			// 		sidemain: () => import('../pages/techtitans/Values.vue'),
			// 	},
			// },
			{
				name: 'contact',
				path: '/t/contact',
				components: {
					sidemain: () => import('../pages/techtitans/Contact.vue'),
				},
			},
			{
				name: 'smartcontact',
				path: '/t/scontact',
				components: {
					sidemain: () => import('../pages/techtitans/SmartContact.vue'),
				},
			},
			{
				name: 'gamedesign',
				path: '/s/gamedesign',
				components: {
					sidemain: () => import('../pages/ttsections/gamedesign/SectionGameDesign.vue'),
				},
			},
			// {
			// 	name: 'sectionvideo',
			// 	path: '/s/video/:video',
			// 	components: {
			// 		sectionmain: () => import('../components/ttsections/Video.vue'),
			// 	},
			// },
			{
				name: 'animation',
				path: '/s/animation',
				components: {
					sidemain: () => import('../pages/ttsections/animation/SectionAnimation.vue'),
				},
			},
			{
				name: 'sounddesign',
				path: '/s/sounddesign',
				components: {
					sidemain: () => import('../pages/ttsections/sounddesign/SectionSoundDesign.vue'),
				},
			},
			{
				name: 'webdevelopment',
				path: '/s/webdevelopment',
				components: {
					sidemain: () => import('../pages/ttsections/webdevelopment/SectionWebDevelopment.vue'),
				},
			},
			{
				name: 'graphics',
				path: '/s/graphics',
				components: {
					sidemain: () => import('../pages/ttsections/graphics/SectionGraphics.vue'),
				},
			},
			{
				name: 'marketing',
				path: '/s/marketing',
				components: {
					sidemain: () => import('../pages/ttsections/marketing/SectionDigitalMarketing.vue'),
				},
			},
			{
				name: 'sart',
				path: '/s/digitalart',
				components: {
					sidemain: () => import('../pages/ttsections/digitalart/SectionDigitalArt.vue'),
				},
			},
			{
				name: 'computerliteracy',
				path: '/s/computerliteracy',
				components: {
					sidemain: () => import('../pages/ttsections/computerliteracy/SectionComputerLiteracy.vue'),
				},
			},
			{
				name: 'prart',
				path: '/pr/art',
				components: {
					sidemain: () => import('../pages/portfolios/Art.vue')
				}
			},
			{
				name: 'challenge',
				path: '/ch/freelearning',
				components: {
					sidemain: () => import('../pages/challenges/FreeLearningChallenge.vue')
				}
			},
			// {
			// 	name: 'challenge',
			// 	path: '/ch/3dcharacter',
			// 	components: {
			// 		sidemain: () => import('../pages/challenges/International3DcharacterForm.vue')
			// 	}
			// },
			{
				name: 'games',
				path: '/g/:game',
				components: {
					sidemain: () => import('../pages/games/Games.vue'),
				},
			},
			{
				name: 'llearning',
				path: '/l/learning',
				components: {
					sidemain: () => import('../pages/landing/LandingLearning.vue'),
				},
			},
			{
				name: 'lrecruiting',
				path: '/l/recruiting',
				components: {
					sidemain: () => import('../pages/landing/LandingRecruiting.vue'),
				},
			},
			// {
			// 	name: 'mmusic',
			// 	path: '/m/music',
			// 	components: {
			// 		sidemain: () => import('../pages/marketplace/Music.vue'),
			// 	},
			// },
			// {
			// 	name: 'mwebsites',
			// 	path: '/m/websites',
			// 	components: {
			// 		sidemain: () => import('../pages/marketplace/Websites.vue'),
			// 	},
			// },
			// {
			// 	name: 'mdesigns',
			// 	path: '/m/designs',
			// 	components: {
			// 		sidemain: () => import('../pages/marketplace/Designs.vue'),
			// 	},
			// },
			// {
			// 	name: 'morder',
			// 	path: '/m/order',
			// 	components: {
			// 		sidemain: () => import('../pages/marketplace/Order.vue'),
			// 	},
			// },
			// {
			// 	name: 'carreers',
			// 	path: '/c/career',
			// 	components: {
			// 		sidemain: () => import('../pages/careers/Career.vue'),
			// 	},
			// },
			{
				name: 'jpostjob',
				path: '/r/job',
				components: {
					sidemain: () => import('../pages/jobs/Job.vue'),
				},
			},
			{
				name: 'jeditjob',
				path: '/r/job/:jpid',
				components: {
					sidemain: () => import('../pages/jobs/Job.vue'),
				},
			},
			{
				name: 'joblistings',
				path: '/r/joblistings',
				components: {
					sidemain: () => import('../pages/jobs/joblistings/TTJobListings.vue'),
				},
			},
			{
				name: 'jojob',
				path: '/r/openjob/:jpid',
				components: {
					sidemain: () => import('../pages/jobs/OpenJob.vue'),
				},
			},
			{
				name: 'companyadd',
				path: '/c/company/a',
				components: {
					sidemain: () => import('../pages/companies/Company.vue'),
				},
			},
			{
				name: 'companyedit',
				path: '/c/company/e',
				components: {
					sidemain: () => import('../pages/companies/Company.vue'),
				},
			},
			{
				name: 'company',
				path: '/c/company',
				components: {
					sidemain: () => import('../pages/companies/CompanyView.vue'),
				},
			},
			{
				name: 'companyview',
				path: '/c/:cname',
				components: {
					sidemain: () => import('../pages/companies/CompanyView.vue'),
				},
			},
			// {
			// 	name: 'jexpert',
			// 	path: '/j/expert',
			// 	components: {
			// 		sidemain: () => import('../pages/careers/Experts.vue'),
			// 	},
			// },
			// {
			// 	name: 'jcompanies',
			// 	path: '/j/companies',
			// 	components: {
			// 		sidemain: () => import('../pages/careers/Companies.vue'),
			// 	},
			// },
			{
				name: 'search',
				path: '/d/search/:query',
				components: {
					sidemain: () => import('../pages/Search.vue'),
				},
			},
			{
				name: 'signup',
				path: '/members/signup',
				components: {
					sidemain: () => import('../pages/members/SignUp.vue'),
				},
			},
			{
				name: 'confirm',
				path: '/members/confirm/:key',
				components: {
					sidemain: () => import('../pages/members/Confirm.vue'),
				},
			},
			// {
			// 	name: 'invitation',
			// 	path: '/members/invitation/:ref',
			// 	components: {
			// 		sidemain: () => import('../pages/members/Invitation.vue'),
			// 	},
			// },
			{
				name: 'friendinvitation',
				path: '/members/finvitation/:ref',
				components: {
					sidemain: () => import('../pages/members/FriendInvitation.vue'),
				},
			},
			{
				name: 'companysignup',
				path: '/members/companysignup',
				components: {
					sidemain: () => import('../pages/members/CompanySignUp.vue'),
				},
			},
			{
				name: 'sucesss',
				path: '/members/success',
				components: {
					sidemain: () => import('../pages/members/Success.vue'),
				},
			},
			// {
			// 	name: 'login',
			// 	path: '/login',
			// 	components: {
			// 		sidemain: () => import('../pages/login/Login.vue'),
			// 	},
			// },
			{
				name: 'subscriptions',
				path: '/members/subscriptions',
				components: {
					sidemain: () => import('../pages/members/Subscriptions.vue'),
				},
			},
			{
				name: 'subscribe',
				path: '/members/subscribe/:subscription',
				components: {
					sidemain: () => import('../pages/members/Subscribe.vue'),
				},
			},
			{
				name: 'memberscontact',
				path: '/members/contact/:subscription',
				components: {
					sidemain: () => import('../pages/members/Contact.vue'),
				},
			},
			{
				name: 'my',
				path: '/u/my/:page?',
				components: {
					sidemain: () => import('../pages/user/MyTab.vue'),
				},
			},
			{
				name: 'teacher',
				path: '/u/tr/dashboard',
				components: {
					sidemain: () => import('../pages/teachers/TeacherDashboard.vue'),
				},
			},
			{
				name: 'publicteacher',
				path: '/ut/:user',
				components: {
					sidemain: () => import('../pages/teachers/TeacherDashboard.vue'),
				},
			},
			{
				name: 'learners',
				path: '/learners',
				components: {
					sidemain: () => import('../pages/learners/Learners.vue'),
				},
			},
			{
				name: 'quizes',
				path: '/quizes/',
				components: {
					sidemain: () => import('../pages/quiz/Quizes.vue'),
				},
			},
			{
				name: 'quiz',
				path: '/quiz/:qid',
				components: {
					sidemain: () => import('../pages/quiz/Quiz.vue'),
				},
			},
			{
				name: 'quizv',
				path: '/quiz/view/:qid',
				components: {
					sidemain: () => import('../pages/quiz/QuizView.vue'),
				},
			},
			{
				name: 'mydashboard',
				path: '/u/:user',
				components: {
					sidemain: () => import('../pages/user/MyDashboard.vue'),
				},
			},
			{
				name: 'agreement',
				path: '/agreements/termsofuse',
				components: {
					sidemain: () => import('../pages/agreements/TermsOfUse.vue'),
				},
			},
			{
				name: 'privacypolicy',
				path: '/agreements/privacypolicy',
				components: {
					sidemain: () => import('../pages/agreements/PrivacyPolicy.vue'),
				},
			}
		]
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../pages/login/Login.vue')
	},
	{
		path: '/forgotpass',
		name: 'forgotpass',
		component: () => import('../pages/login/ForgotPass.vue')
	},
	{
		path: '/reset-password',
		name: 'resetpass',
		component: () => import('../pages/login/ResetPass.vue')
	},
	// {
	// 	path: '/admin',
	// 	name: 'admin',
	// 	component: () => import('../pages/admin/AdminMain.vue')
	// },
	{
		path: '/adminstats/users',
		name: 'adminstats',
		component: () => import('../pages/admin/AdminMain.vue')
	},
	{
		path: '/adminstats/challenge/:cid',
		name: 'adminchallenges',
		component: () => import('../pages/admin/AdminChallenges.vue')
	},
	{
		path: '/:catchAll(.*)*',
		name: "PageNotFound",
		component: () => import('../pages/errors/404.vue')
	},
	
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
            document.getElementById('app')?.scrollIntoView({ behavior: 'smooth' });
        }
})

// router.beforeEach((to, from, next) => {

		// console.log("to.path", to.path);
		// if (!getCookie("uid")) {
		// 	if (exclude.includes(to.path)) {
		// 		document.location.href = "/login";
		// 		next();
		// 		return;
		// 	}
		// 	if (exclude.includes(to.path)) {
		// 		document.location.href = "/login";
		// 		next();
		// 		return;
		// 	}
		// }

	/* TO ALLOW LOGGEDIN USERS ONLY
	// if (!getCookie("uid")) {
	// 	document.location.href = "/login";
	// 	next();
	// 	return;
	// }
	*/
	// if (String(to.path) == "/" && (!String(from.path).startsWith("/d/") && String(from.path) != "/")) {
	// 	const lastRouteName = localStorage.getItem(LS_ROUTE_KEY) as string;
	// 	if (lastRouteName != "undefined" && lastRouteName != 'home2') {
	// 		next({ name: lastRouteName });
	// 		return;
	// 	}
	// } else {
	// 	if (from.name == 'home2' || String(from.path).startsWith("/d/")) localStorage.setItem(LS_ROUTE_KEY, from.name as string);
	// }

// 	next();
// });


export default router